import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { PsHttpService } from '@patsnap/tahiti-core';
import type { PatSnapSuccessResponseData } from '@patsnap/tahiti-core';
import type { TaskApi, GetTaskListRequest, GetTaskListResponse } from '../task-api';
import type { Task } from '../../types';
import { coreTelecomApiUrlPrefix } from '@telecom/shared/domain-config';

@injectable()
export class TaskApiImpl extends PsHttpService implements TaskApi {
    get options() {
        return {
            baseURL: coreTelecomApiUrlPrefix,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    async getTaskList(params: GetTaskListRequest): Promise<GetTaskListResponse> {
        const result = await this.get<PatSnapSuccessResponseData<GetTaskListResponse>>({
            url: 'ai/task/task-list',
            params,
        });
        return result.data;
    }

    async getTaskDetail(taskId: string): Promise<Task> {
        const result = await this.get<PatSnapSuccessResponseData<Task>>({
            url: `/${taskId}`,
        });
        return result.data;
    }

    async cancelTask(taskId: string): Promise<void> {
        await this.post({
            url: `/${taskId}/cancel`,
        });
    }
}
